import { Invoice } from './invoice';

export class MigratedInvoice extends Invoice {
    refInvoiceId: string = null;
}